export default {
  install: function (Vue) {
    Vue.mixin({
      computed: {
        $isDesktop() {
          return this.$mq.desktop;
        },
        $isDesktopMedium() {
          return this.$mq.desktopMedium;
        },
        $isDesktopLarge() {
          return this.$mq.desktopLarge;
        },
        $isTabletLarge() {
          return this.$mq.tabletLarge;
        },
        $isTabletandMobile() {
          return this.$mq.tablet;
        },
        $isMobile() {
          return this.$mq.mobile;
        },
        $isMobileLandscape() {
          return this.$mq.mobileLandscape;
        },
      },
    })
  }
}